// about section

import React from 'react';
import "../styles/About.css";
import image from '../assets/images/about/about-image.svg';
import sparkle from '../assets/images/about/about-sparkle.svg';

function About() {
  return (
    <div className = "about-section" id="about">
        <div className="about-heading-container">
            <h1 id="about-heading-1">About</h1>
            <h1 id="about-heading-2">Me</h1>
        </div>
        <div className="about-content">
            <div className="about-text">
                <div className="heading-container">
                  <h1 id="heading-1">Lindsey</h1>
                  <h1 id="heading-2">Nielsen</h1>
                </div>
                <h3>UI/UX Designer & Software Developer</h3>
                <p> Hello! I earned my B.A. in Digital Media – Web and Social Platforms from the University of Central Florida in August 2024, 
                    with a minor in Computer Science. I am currently pursuing my M.S. in Cybersecurity, where I am expanding my focus into secure 
                    software design, distributed systems, and operating systems.
                    <br></br>  <br></br>
                    My background blends user-centered design with full-stack development. I enjoy building intuitive interfaces while also 
                    understanding the underlying systems that power them. Recently, my work has focused more deeply on backend architecture, 
                    multithreading, and client-server systems.
                    <br></br>  <br></br>
                    While my portfolio highlights UI/UX projects, my current academic work centers on software security and systems design. 
                    I’m actively seeking Summer 2026 internship opportunities in cybersecurity or secure software engineering.
                </p>
            </div>
            <div className="about-image">
                <img src={sparkle} alt="sparkle" className="sparkle"/>
                <img src={image} alt="Lindsey Nielsen" className="lindsey"  />
                
            </div>
        </div>

    </div>
  );
}

export default About;
